import { render, staticRenderFns } from "./PushStupPopup.vue?vue&type=template&id=7b8c50b2"
import script from "./PushStupPopup.vue?vue&type=script&lang=js"
export * from "./PushStupPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8c50b2')) {
      api.createRecord('7b8c50b2', component.options)
    } else {
      api.reload('7b8c50b2', component.options)
    }
    module.hot.accept("./PushStupPopup.vue?vue&type=template&id=7b8c50b2", function () {
      api.rerender('7b8c50b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/PushStupPopup.vue"
export default component.exports